import React, { useEffect } from "react";
import Modal from "@components/_Revamp/Modal";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription/TitleAndDescription";
import Button from "../Button";
import { styled } from "@linaria/react";
import { isNull } from "lodash";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { Text } from "../Text";
import { css } from "@linaria/core";
import { SCREEN_SIZE } from "@static/screen-size";
import { trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
`;

const modalPadding = css`
.modal-body{
  padding: 24px 16px;
}
@media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
  .modal-body{
  padding: 36px;
}
}`

const ErrorContainer = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -40px;
  margin-bottom: 40px;
  padding: "0 10px";
  text-align: center;
  font-style: normal;
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
  color: #8a8988;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-weight: 600;
  }
`;

interface IErrorModal {
  error: string;
  onCloseFn?: () => void;
  title?: string;
  canBack?: boolean;
  canContact?: boolean;
  modalPath?: string;
}

const titleCss = css`
  white-space: break-spaces;
`;

function ErrorModal({
  error,
  onCloseFn,
  title,
  canBack = true,
  canContact = true,
  modalPath,
}: IErrorModal) {
  const history = useHistory();
  const isErrorModal = onCloseFn ? false : true;
  let formatedError = error.replaceAll("\\n\\n", "\n\n");
  formatedError = formatedError.replaceAll("\\n", "\n");
  useEffect(() => {
    document.body.style.position = "fixed";
    return () => {
      document.body.style.position = "unset";
    };
  });

  useEffect(()=>{
    trackOnLoad({errorPage:{ errorCode:"", errorMsg:error?.toString() || "Hard block error"}})

  },[])

  return (
    <Modal
      show={!isNull(error)}
      isErrorModal={isErrorModal}
      onClose={onCloseFn}
      className={modalPadding}
    >
      <Text
        variant="title"
        align="center"
        margin={"0 0 60px 0"}
        textClass={titleCss}
      >
        {title || "We've encountered an issue"}
      </Text>

      <ErrorContainer>
        {error &&
          formatedError.split(/\r\n|\n|\r/gm).map((line) => {
            return (
              <>
                {line}
                <br />
              </>
            );
          })}
      </ErrorContainer>
      <ButtonContainer>
        {canBack ? (
          <Button
            variant="secondary"
            label="Back to home"
            width="180px"
            height="52px"
            onClick={() => {
              isErrorModal
                ? history.push({
                    pathname: ROUTE_PATH.EVER_GREEN_GET_STARTED,
                    state: { noBackButton: true },
                  })
                : history.push(ROUTE_PATH.EVER_GREEN_GET_STARTED);
            }}
          />
        ) : null}
        {canContact ? (
          <Button
            variant="default"
            label="Contact us"
            width="180px"
            height="52px"
            onClick={() => {
              const params =
                modalPath === ROUTE_PATH.EVER_GREEN_MY_INFO
                  ? "?previous=myInfo"
                  : "";
              isErrorModal
                ? history.push({
                    pathname: ROUTE_PATH.EVER_GREEN_CONTACTUS,
                    state: { noBackButton: true },
                    search: params,
                  })
                : history.push(ROUTE_PATH.EVER_GREEN_CONTACTUS + params);
            }}
          />
        ) : null}
      </ButtonContainer>
    </Modal>
  );
}

export default ErrorModal;
